"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconDataCenter = function IconDataCenter(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M7.94 18.98A3.32 3.32 0 0 1 7 16.665v-7.37a3.31 3.31 0 0 1 3.31-3.315h27.36A3.334 3.334 0 0 1 41 9.295v8.011c0 .732-.294 1.395-.77 1.878.475.572.763 1.307.77 2.11v8.012c0 .732-.294 1.395-.77 1.878.475.572.763 1.307.77 2.11v8.012a2.67 2.67 0 0 1-2.67 2.674H10.339a3.3 3.3 0 0 1-2.36-.96A3.32 3.32 0 0 1 7 40.664v-7.37c0-.9.359-1.718.94-2.315A3.32 3.32 0 0 1 7 28.665v-7.37c0-.9.359-1.718.94-2.315m30.39-1.003H10.322A1.31 1.31 0 0 1 9 16.665v-7.37a1.31 1.31 0 0 1 1.31-1.312h27.36c.73 0 1.324.59 1.33 1.32v8.003c0 .37-.3.671-.67.671m0 12H10.322A1.31 1.31 0 0 1 9 28.665v-7.37a1.31 1.31 0 0 1 1.31-1.312h27.36c.73 0 1.324.59 1.33 1.32v8.003c0 .37-.3.671-.67.671m-28.008 12H38.33c.37 0 .67-.3.67-.67v-8.004a1.33 1.33 0 0 0-1.33-1.32H10.31A1.31 1.31 0 0 0 9 33.295v7.37a1.313 1.313 0 0 0 1.322 1.312M20 23a1 1 0 1 0-2 0v4a1 1 0 1 0 2 0zm5 0a1 1 0 1 0-2 0v4a1 1 0 1 0 2 0zm-10 0a1 1 0 1 0-2 0v4a1 1 0 1 0 2 0zm18 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4m0 1a1 1 0 1 1 0 2 1 1 0 0 1 0-2M19 10a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0v-4a1 1 0 0 1 1-1m5 0a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0v-4a1 1 0 0 1 1-1m-10 0a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0v-4a1 1 0 0 1 1-1m17 3a2 2 0 1 1 4 0 2 2 0 0 1-4 0m3 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0M20 35a1 1 0 1 0-2 0v4a1 1 0 1 0 2 0zm5 0a1 1 0 1 0-2 0v4a1 1 0 1 0 2 0zm-10 0a1 1 0 1 0-2 0v4a1 1 0 1 0 2 0zm18 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4m0 1a1 1 0 1 1 0 2 1 1 0 0 1 0-2",
    clipRule: "evenodd"
  })));
};

export { IconDataCenter, IconDataCenter as default };
